import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import ContentDiv from "../utils/ContentDiv";

class HomeContent extends Component {
	render() {
		const { translations } = this.props;

		// If reviewer is logged in, it'll be a 50% column.  If not, all the way baby
		const classNames = !this.props.reviewer ? "section-content" : "section-home--smaller";

		return (
			<React.Fragment>
				<div className={`section section-home ${classNames}`}>
					<ContentDiv>{translations.pages.home.content}</ContentDiv>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		reviewer: state.user.reviewer
	};
};

export default connect(
	mapStateToProps,
	null
)(HomeContent);



// WEBPACK FOOTER //
// ./src/components/home/HomeContent.js